<script setup>
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import { copyTextToClipboard } from 'shared/helpers/clipboard';
import { frontendURL, conversationUrl } from 'dashboard/helper/URLHelper';
import wootConstants from 'dashboard/constants/globals';
import ContextMenu from 'dashboard/components/ui/ContextMenu.vue';
import MenuItem from 'dashboard/components/widgets/conversation/contextMenu/menuItem.vue';

const props = defineProps({
  conversationId: {
    type: Number,
    required: true,
  },
  x: {
    type: Number,
    default: null,
  },
  y: {
    type: Number,
    default: null,
  },
});

const emit = defineEmits(['close']);

const { t } = useI18n();
const store = useStore();

const accountId = store.getters.getCurrentAccountId;

const conversationPath = frontendURL(
  conversationUrl({
    accountId,
    id: props.conversationId,
  })
);

const copyConversationLink = async () => {
  const url = `${window.chatwootConfig.hostURL}${conversationPath}`;
  await copyTextToClipboard(url);
  useAlert(t('CONVERSATION.CARD_CONTEXT_MENU.COPY_LINK_SUCCESS'));
  emit('close');
};

const resolveConversation = async () => {
  await store.dispatch('toggleStatus', {
    conversationId: props.conversationId,
    status: wootConstants.STATUS_TYPE.RESOLVED,
  });
  emit('close');
};
</script>

<template>
  <ContextMenu :x="x" :y="y" @close="$emit('close')">
    <div
      class="p-1 rounded-md shadow-xl bg-n-alpha-3/50 backdrop-blur-[100px] outline-1 outline outline-n-weak/50"
    >
      <MenuItem
        :option="{
          label: $t('CONVERSATION.CARD_CONTEXT_MENU.COPY_LINK'),
          icon: 'copy',
        }"
        variant="icon"
        @click.stop="copyConversationLink"
      />
      <MenuItem
        :option="{
          label: $t('CONVERSATION.CARD_CONTEXT_MENU.RESOLVED'),
          icon: 'checkmark',
        }"
        variant="icon"
        @click.stop="resolveConversation"
      />
    </div>
  </ContextMenu>
</template>
